import { permute } from "@/views/configuration/importing-data/views/rules-configuration/utils/permute";
import { RuleActionContext } from "@/views/configuration/importing-data/constants/rule-action-context";

import { CARD_TYPE } from "./card-type";

export const invalidHeaderCharactersRegex = /[^a-zA-Z0-9_]/g;
export const invalidNumberRegex = /[^0-9]/g;

const dimensions = [0, 1, 2];
const dimensionMapping: Record<number, string> = {
	0: "L",
	1: "W",
	2: "H",
};

export const DIMENSION_PERMUTATIONS = [...permute(dimensions, 3), ...permute(dimensions, 2)]
	.sort((a: number[], b: number[]) => a.join("").localeCompare(b.join("")))
	.map((c: number[]) => c.map((d) => dimensionMapping[d]));

export const DIMENSION_PERMUTATION_OPTIONS = [...DIMENSION_PERMUTATIONS.map((d) => d.join("")), "NONE"];

export const CARD_TYPE_MAPPING = {
	[RuleActionContext.Solution]: CARD_TYPE.JOB_INFORMATION,
	[RuleActionContext.Carton]: CARD_TYPE.CARTON_INFORMATION,
	[RuleActionContext.Label]: CARD_TYPE.LABEL_INFORMATION,
};

export const RULE_CONSTANTS = {
	"SplitStringByDelimiter.IgnoreMe": "[IgnoreMe]",
};

export const READ_ONLY_PACKNET_FIELDS = ["JobInformation.Command", "JobInformation.SavedJobAlias"];

export const RULE_EXECUTION_SOURCE = {
	IMPORT: "Import",
	PACKAGING_CREATION: "PackagingCreation",
	DIM: "Dim",
} as const;

export type ExecutionSource = (typeof RULE_EXECUTION_SOURCE)[keyof typeof RULE_EXECUTION_SOURCE];
